import script from "./Transactions.vue?vue&type=script&setup=true&lang=js"
export * from "./Transactions.vue?vue&type=script&setup=true&lang=js"

import "./Transactions.vue?vue&type=style&index=0&id=43eda38a&lang=css"

const __exports__ = script;

export default __exports__